module.exports = __webpack_public_path__ + "img/4064000560.e9ccbc32.jpg";